import { useQuery } from "@tanstack/react-query";

import { useSupabase } from "@/auth/SupabaseProvider";

import { apiFetch } from "./client";
import type { UsageSummaryResponse } from "./types";

interface UseUsageSummaryParams {
  /** Window in hours; backend caps at 720. Default 24. */
  sinceHours?: number;
}

export function useUsageSummary({ sinceHours = 24 }: UseUsageSummaryParams = {}) {
  const { client } = useSupabase();
  return useQuery({
    queryKey: ["usage-summary", sinceHours],
    queryFn: ({ signal }) =>
      apiFetch<UsageSummaryResponse>(client, "/api/usage/summary", {
        signal,
        query: { since: sinceHours },
      }),
  });
}
